<template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-actions>
                    <div class="title">Orders</div>
                    <v-spacer></v-spacer>
                    <ManifestDialog>
                      <template v-slot:activator="{on}">
                        <v-btn v-on="on" :loading="!finishedLoading" :disabled="!finishedLoading">Manifests</v-btn>
                      </template>
                    </ManifestDialog>
                    <v-spacer></v-spacer>
                    <CaCreateOrder>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on">Create Order</v-btn>
                        </template>
                    </CaCreateOrder>
                </v-card-actions>
                <v-card-text>
                    <v-data-table
                            v-if="samples"
                            :headers="controls.headers"
                            :items="samples"
                            item-key="uuid"
                            :search="controls.search"
                            :expanded.sync="controls.expanded"
                            :custom-filter="customFilter"
                            disable-pagination
                            hide-default-footer
                            sort-by="id"
                            sort-desc
                    >
                        <template v-slot:top>
                            <v-text-field
                                    v-model="controls.search"
                                    label="Search"
                            >
                            </v-text-field>
                        </template>
                        <template v-slot:item.uuid="{item}">
                            <SampleEditForm :sample="item"></SampleEditForm>
                        </template>
                      <template v-slot:item.notes_and_flags="{item}">
                        <SampleNotesAndFlags :sample="item"></SampleNotesAndFlags>
                      </template>
                      <template v-slot:item.print_label="{item}">
                        <LabelPrinterContextMenu :label="label">
                          <template v-slot:activator="{show}">
                            <v-btn @click="printLabel(item)" @contextmenu="show" small outlined tile>Print Label</v-btn>
                          </template>
                        </LabelPrinterContextMenu>

                      </template>
                      <template v-slot:item.sample_cert_type="{item}">
                          <v-sheet :color="item.sample_cert_type.color" class="text-center white--text" style="white-space:nowrap" width="80" height="100%">
                            <v-row
                                class="fill-height"
                                align="center"
                                justify="center"
                            >
                              <div>
                                {{item.sample_cert_type.name}}
                              </div>
                            </v-row>
                          </v-sheet>
                      </template>
                      <template v-slot:item.required_tests="{item}">
                        <td style="width: 1%; white-space:nowrap">
                          <RequiredTests :sample="item" chips></RequiredTests>
                        </td>
                      </template>
                        <template v-slot:item.customer="{item}">
                          {{item.customer.primary_name.name}}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import SampleEditForm from './components/SampleEditForm'
    import ManifestDialog from './Manifests';
    import CaCreateOrder from './components/CreateOrder'
    import CreateOrder from "../../components/orders/CreateOrder";
    import RequiredTests from "@/components/general/samples/RequiredTests";
    import FrontOfficeLabel from "@/Lib/Labels/FrontOfficeLabel";
    import SampleNotesAndFlags from "@/views/orders/components/SampleNotesAndFlags";
    import LabelPrinterContextMenu from "@/views/orders/components/LabelPrinterContextMenu";
    import Label from "@/Lib/LabelPrinter";
    export default {
        name: "index",
        components:{
          SampleEditForm,
            ManifestDialog,
            CaCreateOrder,
            CreateOrder,
          RequiredTests,
          SampleNotesAndFlags,
          LabelPrinterContextMenu
        },
        data: () => ({
            controls:{
                createOrder: false,
                headers: [
                  {text: "Edit", value: "uuid"},
                  {text: "Notes/Flags", value: "notes_and_flags"},
                  {text: "Print Label", value: "print_label"},
                  {text: "Sample ID", value: "id"},
                  {text: "Customer", value: "customer"},
                  {text: "Sample Type", value: "sample_cert_type"},
                  {text: "Required Tests", value: "required_tests"},
                  {text: "Name", value: "name"},
                  {text: "QA", value: "qa"},
                  {text: "LOT", value: "lot"},
                ],
                expanded: [],
                search: null
            },
           label: null,
        }),
        computed:{
          finishedLoading(){
            return this.$store.$db().model('units').query().count() > 0 &&
            this.$store.$db().model('sampleTestTypes').query().count() > 0 &&
            this.$store.$db().model('imperatives').query().count() > 0 &&
            this.$store.$db().model('sampleCertTypes').query().count() > 0 &&
            this.$store.$db().model('customers').query().count() > 0
          },
          names() {
            return this.$store.$db().model('names').all();
          },
          samples(){
            return this.$store.$db().model('samples').query().with(['sample_tests.test_type', 'customer', 'sample_cert_type', 'sample_flags.flag_type', 'sample_notes.note_type']).all();
          }
        },
        mounted(){
            this.label = new Label(dymo);
            this.getSamples();
            this.$store.dispatch('entities/units/deleteAll');
            // this.$store.dispatch('entities/sampleTestTypes/deleteAll');
            this.$store.dispatch('entities/imperatives/deleteAll');
            // this.$store.dispatch('entities/sampleCertTypes/deleteAll');
            this.$store.dispatch('entities/names/deleteAll');
            this.$store.$db().model('units').api().fetch();
            // this.$store.$db().model('sampleFlagTypes').api().fetch();
            // this.$store.$db().model('sampleTestTypes').api().fetch();
            this.$store.$db().model('sampleNoteTypes').api().fetch();
            this.$store.$db().model('imperatives').api().fetch({
            with: "imperativeType"
          });
          //   this.$store.$db().model('sampleCertTypes').api().fetch({
          //   with: "requirements"
          // });
            this.$store.$db().model('customers').api().fetch({with: 'primaryName'});
            this.$store.$db().model('names').api().fetch();
        },
        methods:{
            customFilter (value, search, item) {
              let stringed = JSON.stringify(item).toString().replace(/"/g, '').replace(/requirements:\[(\{.*\})\}\]/, '');
              return value != null &&
                  search != null &&
                  typeof value !== 'boolean' &&
                  stringed.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
            },
            async getSamples(){
                await this.$store.$db().model('samples').api().fetch({
                    with:"sampleTests,sampleNotes,sampleFlags",
                    not_null: 'order_id',
                    where: [
                      {key: 'is_released', value: false}
                    ],
                    order_by_desc: 'id'
                });
            },
            customer(sample){
                if(this.names.length < 1) return '';
                if(sample.customer_name_id){
                  return this.names.find(name => name.id === sample.customer_name_id).name;
                }
                return this.names.filter(name => name.name_type_id === 1).find(name => name.customer_id === sample.customer_id).name;
            },
            filterSearch(value, search, item){
                let sampleSearch = item.samples.filter(sample => { return sample.id.toString().includes(search) }).length > 0;
                return sampleSearch ||  (value && value.toLowerCase().includes(search.toLowerCase()) );
            },
            printLabel(sample){
              this.label.setPrinter();
              this.label.setLabel(FrontOfficeLabel.label());
              this.label.createLabels(sample);
              this.label.print()
            }
        },
      beforeRouteLeave(from, to, next){
        this.$store.$db().model('customers').deleteAll();
        this.$store.$db().model('names').deleteAll();
        this.$store.$db().model('billings').deleteAll();
        this.$store.$db().model('imperatives').deleteAll();
        this.$store.$db().model('imperativeTypes').deleteAll();
        this.$store.$db().model('samples').deleteAll();
        this.$store.$db().model('sampleTests').deleteAll();
        next();
      }
    }
</script>

<style scoped>

</style>
